import type { Currency, DocumentJsonIn, DocumentRow, ManualLineIn } from "./api";

export type DocumentForm = { kind: "pdf" | "xero"; file: File | null; source_account: string; document_date: string; total_amount: string; currency: Currency; fx_rate: string; portion_amount: string; reference: string };
export type DocumentBody = { kind: "multipart"; form: FormData } | { kind: "json"; body: DocumentJsonIn };
const MONEY = /^\d{1,16}(\.\d{1,2})?$/;
const RATE = /^\d{1,10}(\.\d{1,8})?$/;

export function documentProblems(form: DocumentForm, bookCurrency: Currency): string[] {
  const problems: string[] = [];
  if (form.kind === "pdf" && !form.file) problems.push("Choose a PDF.");
  if (form.kind === "xero" && !form.reference.trim()) problems.push("Type the Xero invoice number.");
  if (!form.source_account) problems.push("Pick the account.");
  if (!form.document_date) problems.push("Enter the document date.");
  if (!MONEY.test(form.total_amount) || Number(form.total_amount) <= 0) problems.push("Total must be above zero (2 decimals).");
  if (!MONEY.test(form.portion_amount) || Number(form.portion_amount) <= 0) problems.push("Portion must be above zero (2 decimals).");
  if (MONEY.test(form.total_amount) && MONEY.test(form.portion_amount) && Number(form.portion_amount) > Number(form.total_amount)) problems.push("Portion cannot exceed the document total.");
  if (form.currency !== bookCurrency && form.fx_rate && !RATE.test(form.fx_rate)) problems.push("Exchange rate: up to 8 decimals.");
  return problems;
}
export function documentBody(form: DocumentForm, bookCurrency: Currency, docId: string): DocumentBody {
  const fx = form.currency !== bookCurrency && form.fx_rate ? form.fx_rate : null;
  if (form.kind === "xero") return { kind: "json", body: { doc_type: "xero_bill", doc_id: docId, source_account: form.source_account, reference: form.reference.trim(), document_date: form.document_date, total_amount: form.total_amount, currency: form.currency, ...(fx ? { fx_rate: fx } : {}), portion_amount: form.portion_amount } };
  const data = new FormData();
  data.set("doc_type", "pdf_upload"); data.set("doc_id", docId); data.set("source_account", form.source_account); data.set("document_date", form.document_date);
  data.set("total_amount", form.total_amount); data.set("currency", form.currency); data.set("portion_amount", form.portion_amount);
  if (fx) data.set("fx_rate", fx); if (form.reference.trim()) data.set("reference", form.reference.trim());
  if (form.file) data.set("file", form.file, form.file.name);
  return { kind: "multipart", form: data };
}
export function fxWords(row: Pick<DocumentRow, "fx_source" | "fx_rate" | "document_date" | "currency">): string {
  switch (row.fx_source) {
    case "book": return "same currency";
    case "ecb_date": return `ECB rate ${row.fx_rate} on ${row.document_date}`;
    case "xero_document": return `Xero document rate ${row.fx_rate}`;
    case "typed": return `typed rate ${row.fx_rate}`;
  }
}
export function manualPayload(account: string, amount: string, reason: string, lineId: string): ManualLineIn { return { source_account: account, amount: amount.trim(), reason: reason.trim(), line_id: lineId }; }
export function manualProblems(account: string, amount: string, reason: string): string[] {
  const problems: string[] = [];
  if (!account) problems.push("Pick the account.");
  if (!/^-?\d{1,16}(\.\d{1,2})?$/.test(amount.trim()) || Number(amount) === 0) problems.push("Amount must be non-zero (2 decimals; negative allowed).");
  if (!reason.trim()) problems.push("A reason is required.");
  return problems;
}
